import { LANDING } from "@/constants/testIds";

const PORTRAIT = "/images/kristy-portrait.jpg";

export default function About() {
  return (
    <section
      id="about"
      data-testid={LANDING.aboutSection}
      className="relative bg-[#F4F1EA] py-24 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
        {/* Text */}
        <div className="md:col-span-5 md:pt-8">
          <div className="reveal flex items-center gap-3 mb-8">
            <span className="h-px w-8 bg-[#C05A44]" />
            <span className="font-mono-editorial text-[11px] text-[#C05A44]">
              01 · THE CHEF
            </span>
          </div>

          <h2 className="reveal font-display font-light text-[#1A2B3C] leading-[1.02] text-4xl md:text-5xl lg:text-6xl tracking-tight">
            A private table,
            <br />
            <span className="italic">shaped by the sea.</span>
          </h2>

          <div
            className="reveal mt-10 space-y-6 font-body text-[#5C6B7A] text-base md:text-lg leading-relaxed"
            style={{ transitionDelay: "80ms" }}
          >
            <p>
              Kristy Worrell is a Bahamian-born personal chef whose kitchen
              lives at the meeting point of Caribbean tradition and modern
              coastal cuisine. From line-caught grouper to conch harvested
              that morning, every plate begins on the water.
            </p>
            <p>
              She trained in the islands and refined her craft in kitchens
              across the Atlantic — returning home with a single conviction:
              the finest hospitality feels intimate, unhurried, and unmistakably
              of this place.
            </p>
          </div>

          <div
            className="reveal mt-12 grid grid-cols-3 gap-6 max-w-md border-t border-[#1A2B3C]/15 pt-8"
            style={{ transitionDelay: "160ms" }}
          >
            <div>
              <div className="font-display text-4xl text-[#1A2B3C]">12+</div>
              <div className="font-mono-editorial text-[10px] text-[#5C6B7A] mt-2">
                YEARS
              </div>
            </div>
            <div>
              <div className="font-display text-4xl text-[#1A2B3C]">300+</div>
              <div className="font-mono-editorial text-[10px] text-[#5C6B7A] mt-2">
                EVENTS
              </div>
            </div>
            <div>
              <div className="font-display text-4xl text-[#1A2B3C]">7</div>
              <div className="font-mono-editorial text-[10px] text-[#5C6B7A] mt-2">
                ISLANDS
              </div>
            </div>
          </div>
        </div>

        {/* Portrait */}
        <div className="md:col-span-7 relative">
          <div className="reveal relative">
            {/* Backdrop block */}
            <div className="absolute -top-6 -left-6 md:-top-10 md:-left-10 w-4/5 h-4/5 bg-[#4A5D4E]" />
            <img
              src={PORTRAIT}
              alt="Signature dish plated by Chef Kristy Worrell"
              className="relative w-full h-[520px] md:h-[720px] object-cover"
              loading="lazy"
            />
            <div className="absolute -bottom-6 right-4 md:right-8 bg-[#F4F1EA] px-6 py-4 border border-[#1A2B3C]/15 max-w-[280px]">
              <div className="font-mono-editorial text-[10px] text-[#C05A44] mb-1">
                SIGNATURE
              </div>
              <div className="font-display italic text-xl text-[#1A2B3C] leading-snug">
                “Cook the island, plate the moment.”
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
